import { Avatar, Box, Button, Chip, Stack, TextField, Tooltip, Typography } from '@mui/material';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import TournamentSetupShieldPicker from './TournamentSetupShieldPicker';

/** Pestaña «Solo equipos». */
export default function TournamentSetupPoolTab({
  teams,
  availableTeams,
  busy,
  poolTeamName,
  setPoolTeamName,
  poolTeamShield,
  setPoolTeamShield,
  handleCreatePoolTeam,
  handleRemoveTeamFromTournament,
  onFileTooLargeShield,
  openTeamLibrary,
  onPickFromLibraryForPool,
}) {
  return (
    <>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, lineHeight: 1.6 }}>
        Mismo flujo que en la primera pestaña: equipos con escudo en la bolsa y luego reparto a grupos. Aquí tienes la
        lista completa del torneo.
      </Typography>
      <Box
        component="form"
        onSubmit={handleCreatePoolTeam}
        sx={{
          mb: 2,
          p: 2,
          borderRadius: 2,
          bgcolor: 'rgba(15,107,92,0.06)',
          border: '1px solid rgba(15,107,92,0.12)',
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', display: 'block', mb: 1 }}>
          Nuevo equipo (bolsa)
        </Typography>
        <TournamentSetupShieldPicker
          value={poolTeamShield}
          onChange={setPoolTeamShield}
          disabled={busy}
          onFileTooLarge={onFileTooLargeShield}
        />
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mt: 1.5 }} alignItems={{ sm: 'center' }}>
          <TextField
            size="small"
            label="Nombre"
            value={poolTeamName}
            onChange={(e) => setPoolTeamName(e.target.value)}
            sx={{ flex: 1, minWidth: 200 }}
            disabled={busy}
          />
          <Button
            type="submit"
            variant="contained"
            disabled={busy || !poolTeamName.trim()}
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              bgcolor: '#0f6b5c',
              '&:hover': { bgcolor: '#0c5a4e' },
            }}
          >
            Dar de alta en la bolsa
          </Button>
        </Stack>
        {openTeamLibrary && onPickFromLibraryForPool ? (
          <Button
            type="button"
            variant="outlined"
            size="small"
            startIcon={<BookmarkBorderIcon />}
            disabled={busy}
            onClick={() => openTeamLibrary(onPickFromLibraryForPool)}
            sx={{
              mt: 1.5,
              textTransform: 'none',
              fontWeight: 700,
              borderColor: 'rgba(15,53,49,0.3)',
              color: '#0f3531',
              '&:hover': { borderColor: '#0f6b5c', bgcolor: 'rgba(15,107,92,0.06)' },
            }}
          >
            Elegir de mi biblioteca
          </Button>
        ) : null}
      </Box>
      <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', display: 'block', mb: 1 }}>
        En la bolsa ({availableTeams.length}) · Total en torneo ({teams.length})
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 2 }}>
        {teams.map((t) => {
          const inPool = availableTeams.some((a) => a.id === t.id);
          const chip = (
            <Chip
              key={t.id}
              avatar={
                <Avatar src={t.shield || undefined} alt="">
                  {!t.shield ? (t.name || '?').charAt(0) : null}
                </Avatar>
              }
              label={t.name}
              variant="outlined"
              color={inPool ? 'warning' : 'default'}
              onDelete={
                inPool && handleRemoveTeamFromTournament
                  ? () => handleRemoveTeamFromTournament(t.id, t.name)
                  : undefined
              }
              disabled={busy}
              sx={{
                borderColor: inPool ? 'rgba(201,162,39,0.5)' : 'rgba(15,53,49,0.2)',
                fontWeight: 600,
              }}
            />
          );
          if (inPool && handleRemoveTeamFromTournament) {
            return (
              <Tooltip key={t.id} title="Quitar del torneo (solo si no está en grupos ni en partidos)">
                {chip}
              </Tooltip>
            );
          }
          return chip;
        })}
      </Stack>
      {teams.length === 0 && <Typography color="text.secondary">No hay equipos todavía.</Typography>}
    </>
  );
}
